// src/pages/userProfile/FakturyTab.js
import React, { useEffect, useState } from 'react';
import { Alert, Button, List, message, Modal, Spin, Tag, Upload } from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { ref as dbRef, get } from 'firebase/database';
import moment from 'moment';
import { useFirebase } from '../../FirebaseContext';
import { addInvoiceForDriver } from '../../services/invoicesService';

const FakturyTab = ({ userData }) => {
  const { currentFirebase } = useFirebase();
  const driverId = userData?.driverId;

  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    if (!driverId) { setLoading(false); return; }
    setLoading(true);
    try {
      const snap = await get(dbRef(currentFirebase.database, `/drivers/${driverId}/invoices`));
      const val = snap.exists() ? snap.val() : {};
      const list = Object.entries(val).map(([id, v]) => ({ id, ...v })).sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
      setInvoices(list);
    } catch (e) {
      message.error('Błąd ładowania faktur');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [driverId]);

  const handleAdd = async () => {
    if (fileList.length === 0) { message.error('Wybierz plik'); return; }
    setSaving(true);
    try {
      await addInvoiceForDriver({
        storage: currentFirebase.storage,
        database: currentFirebase.database,
        driverId,
        file: fileList[0].originFileObj,
      });
      message.success('Faktura dodana');
      setModalOpen(false);
      setFileList([]);
      await load();
    } catch (e) {
      message.error(`Błąd: ${e.message}`);
    } finally {
      setSaving(false);
    }
  };

  if (!driverId) {
    return <Alert type="warning" showIcon message="Brak driverId" description="Użytkownik nie ma przypisanego ID kierowcy — nie można dodać faktury." />;
  }

  return (
    <div>
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalOpen(true)} style={{ marginBottom: 16 }}>
        Dodaj fakturę
      </Button>

      {loading ? <Spin /> : (
        <List
          dataSource={invoices}
          locale={{ emptyText: 'Brak faktur' }}
          renderItem={(inv) => (
            <List.Item
              actions={inv.fileURL ? [<Button type="link" href={inv.fileURL} target="_blank" rel="noreferrer">Otwórz</Button>] : []}
            >
              <List.Item.Meta
                title={<>{inv.originalFileName || inv.fileName || 'Faktura'} <Tag>{inv.status || '-'}</Tag>{inv.addedBy === 'admin' && <Tag color="blue">admin</Tag>}</>}
                description={inv.uploadDate || (inv.timestamp ? moment(inv.timestamp).format('YYYY-MM-DD HH:mm') : '')}
              />
            </List.Item>
          )}
        />
      )}

      <Modal title="Dodaj fakturę" open={modalOpen} onCancel={() => { setModalOpen(false); setFileList([]); }} onOk={handleAdd} confirmLoading={saving} okText="Dodaj" cancelText="Anuluj">
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          fileList={fileList}
          onChange={({ fileList: fl }) => setFileList(fl)}
        >
          <Button icon={<UploadOutlined />}>Wybierz plik</Button>
        </Upload>
      </Modal>
    </div>
  );
};

export default FakturyTab;
